import React from "react"
import ContactezNous from "gatsby-theme-blank/src/pages/contactez-nous"

const ContactezNousCactus = () => <ContactezNous arianeDisplayed={true} />

export default ContactezNousCactus
